module.exports = __webpack_public_path__ + "static/media/portfolio .a1f308d7.jpg";